"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("@jsluna/form");

var _placeholder = _interopRequireDefault(require("../../assets/placeholder.png"));

var _constants = require("../../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ImageSelection = function ImageSelection(_ref) {
  var options = _ref.options,
      onImageSelected = _ref.onImageSelected,
      disabled = _ref.disabled,
      questionId = _ref.questionId,
      isRequired = _ref.isRequired;

  var _useState = (0, _react.useState)([]),
      selectedOptions = _useState[0],
      setSelectedOptions = _useState[1];

  var _useState2 = (0, _react.useState)(!isRequired),
      isValid = _useState2[0],
      setIsValid = _useState2[1];

  var findLunaCheckboxInputForOption = function findLunaCheckboxInputForOption(ref) {
    return ref.children[1].children[0];
  };

  var handleOptionSelected = function handleOptionSelected(option) {
    var newSelectedOptions = [];
    var isNoneOfTheAboveOption = option.title === _constants.NONE_OF_THE_ABOVE_TITLE;

    if (isNoneOfTheAboveOption && !selectedOptions.includes(option)) {
      newSelectedOptions = [option];

      for (var i = 0; i < selectedOptions.length; i += 1) {
        findLunaCheckboxInputForOption(selectedOptions[i].ref).click();
      }
    } else if (!isNoneOfTheAboveOption) {
      var noneOfTheAboveOption = selectedOptions.find(function (x) {
        return x.title === _constants.NONE_OF_THE_ABOVE_TITLE;
      });

      if (noneOfTheAboveOption) {
        findLunaCheckboxInputForOption(noneOfTheAboveOption.ref).click();
      }

      var allOptionsExcludingNoneOfTheAbove = selectedOptions.filter(function (x) {
        return x.title !== _constants.NONE_OF_THE_ABOVE_TITLE;
      });
      newSelectedOptions = allOptionsExcludingNoneOfTheAbove.includes(option) ? allOptionsExcludingNoneOfTheAbove.filter(function (x) {
        return x !== option;
      }) : [].concat(allOptionsExcludingNoneOfTheAbove, [option]);
    }

    onImageSelected(newSelectedOptions.map(function (opt) {
      return opt.number;
    }).toString());
    setSelectedOptions(newSelectedOptions);
    setIsValid(newSelectedOptions.length > 0);
  };

  return /*#__PURE__*/_react.default.createElement(_form.FormGroup, {
    name: questionId,
    error: !isValid && _constants.VALIDATION_ERROR
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "image-selector-options-container"
  }, options && options.length > 0 && options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: function ref(_ref2) {
        return option.ref = _ref2;
      },
      key: questionId + option.number,
      className: "image-selector " + (selectedOptions.includes(option) ? 'ln-u-border-orange' : '')
    }, disabled && /*#__PURE__*/_react.default.createElement("h1", null, option.number), /*#__PURE__*/_react.default.createElement("div", {
      className: "image"
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: "img-opt-preview",
      loading: "lazy",
      src: option.value.length > 0 ? option.value : _placeholder.default
    })), /*#__PURE__*/_react.default.createElement(_form.Checkbox, {
      name: "checkbox-" + questionId + "-" + option.number,
      label: option.title,
      className: "checkbox",
      fullWidth: true,
      onClick: function onClick() {
        return handleOptionSelected(option);
      },
      disabled: disabled
    }));
  })));
};

ImageSelection.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    number: _propTypes.default.number.isRequired,
    title: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired
  })),
  onImageSelected: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  isRequired: _propTypes.default.bool,
  questionId: _propTypes.default.string
};
ImageSelection.defaultProps = {
  options: [],
  onImageSelected: function onImageSelected() {},
  disabled: false,
  isRequired: false,
  questionId: ''
};
var _default = ImageSelection;
exports.default = _default;